<div class="relative z-10">
  <div
    class="fixed inset-0 bg-gray-500 bg-opacity-40"
    [ngClass]="isOpen ? 'block' : 'hidden'"
    (click)="isOpen = false"
  ></div>

  <button
    class="bg-white rounded-lg relative outline-none"
    (click)="isOpen = !isOpen"
    [ngClass]="extraClass"
  >
    <ng-content></ng-content>
  </button>
  <div
    class="absolute top-16 -right-4 md:right-0 w-screen md:w-auto overflow-y-auto"
    [ngClass]="isOpen ? 'block' : 'hidden'"
  >
    <div
      class="flex min-h-full items-end justify-center p-3 text-center sm:items-center sm:p-0"
    >
      <div
        class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all w-full sm:w-80"
      >
        <div class="bg-white flex flex-col px-4 py-5 sm:p-4">
          <div class="flex flex-col gap-4 items-center">
            <p class="text-base font-medium">Categorias</p>
            <div class="flex justify-center mb-2 flex-wrap gap-2">
              <mobo-btn-check
                *ngFor="let category of categories"
                [isSelected]="isChecked(category.Id || category.CategoriesIds)"
                (check)="addCategory(category)"
              >
                {{ category.Name }}
              </mobo-btn-check>
            </div>
            <p class="text-base font-medium">Momentos do dia</p>
            <div class="flex justify-center mb-2 flex-wrap gap-2">
              <mobo-btn-check
                *ngFor="let moment of moments"
                [isSelected]="isChecked(moment.Id)"
                (check)="addMoment(moment)"
                >{{ moment.NameOrigin }}
              </mobo-btn-check>
            </div>
          </div>
        </div>
        <div class="px-4 pb-4 flex flex-col">
          <button
            class="px-6 py-2 bg-primary-500 hover:bg-primary-700 hover:border-primary-700 rounded-full border-2 border-blue-600 justify-center items-center gap-1 flex text-center text-white text-base font-medium"
            (click)="emitFilterDone()"
          >
            Aplicar filtros
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
